"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactive = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./interactive.css");
/** The interactive card is a container for a form element (radio/checkbox). It is used inside a card component.
 *  It's useful when you want to organize the information of the available options. */
const Interactive = ({ children, dataTest = 'interactive', position = 'right', ...other }) => {
    const classes = (0, classnames_1.default)('dsc-cardInteractive', position === 'left' && `is-${position}`);
    return ((0, jsx_runtime_1.jsx)("div", { ...other, className: classes, "data-test": dataTest, children: children }));
};
exports.Interactive = Interactive;
exports.Interactive.displayName = 'Interactive';
//# sourceMappingURL=interactive.js.map